import { Id, PagedMultiSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC, useMemo } from "react";
import { createEventUserService } from "../../api/userService";

interface Props {
	eventId: Id;
	name: string;
	label: string;
	disabled?: boolean;
	clearable?: boolean;
	required?: boolean;
}

export const EventUserGroupMultiSelect: FC<Props> = ({
	eventId,
	name,
	label,
	disabled,
	clearable,
	required = false,
}) => {
	const eventUserService = useMemo(() => createEventUserService(eventId), [eventId]);

	return (
		<PagedMultiSelectField
			name={name}
			label={label}
			fetchConfig={laravelSelectFetchConfig(eventUserService.getAvailableUserGroupsKey, (search, page) =>
				eventUserService.getAvailableUserGroups(search, page).then((r) => r.data),
			)}
			disabled={disabled}
			clearable={clearable}
			required={required}
		/>
	);
};
